import Tb1688Api from './api'
import { Service_GetRelationId } from '@/service/auth_mall_service'

// 获取商品库的筛选标签
async function GetPoolList() {
  var relationId = Service_GetRelationId()
  let { pools } = await Tb1688Api.GetPoolList(relationId)
  pools = pools.filter(item => item.ruleId !== 537707) // 隐藏掉春节不打烊选项
  const newList = []
  // 508286 小二精选,   528506 平价精选 位置改成放在第2个
  const index = pools.findIndex(item => item.ruleId === 528506)
  const item = pools.find(item => item.ruleId === 528506)
  if (index > -1) {
    item.ruleName = '会员专享分销价'
    const t = pools[1]
    pools[1] = item
    pools[index] = t
  }
  for (let item of pools) {
    newList.push({
      value: item.ruleId,
      label: item.ruleName,
      tip: item.ruleDesc.replace('通过ttpft交易flow可享受渠道专属优惠价', '采购下单时可享受专享优惠价'),
      showJxTag: (item.ruleId === 508286 || item.ruleId === 528506) ? true :false
    })
  }
  return { pools: newList }
}

// 1688类目,没有商品数据的: '123614001' 钢铁, 加工,机床, 印刷, 农业, 能源环保
const noDataCateIds = ['2805', '1426', '72', '1', '10', '64']

// 获取1688类目
async function GetCategoryList(data) {
  const result = await Tb1688Api.GetCategoryList(data)
  const newList = []
  if (result.list.length) {
    result.list = result.list.filter(item => !noDataCateIds.includes(item.CatId))
    result.list.map(item => {
      newList.push({
        value: item.CatId,
        label: item.CatName,
        isLeaf: data?.onlyShowTwoCategory || Boolean(item.IsLeaf)
      }) 
    })
    newList.sort((a, b) => a.label.length - b.label.length) // 按类目名称的长度升序
    result.list = newList
  }
  return result
}

// 1688搜词
async function SearchGoodsByKeyword(data) {
  var relationId = Service_GetRelationId()
  const result = await Tb1688Api.SearchGoodsByKeyword(data,relationId)
  const newList = []
  if (result.list?.length) {
    result.list.map(item => {
      newList.push({
        goodsId: item.itemId,
        goodsName: item.title,
        price: item.minPrice / 100,
        sold: item.salesCnt90d,
        imageUrl: item.imgUrl,
        serviceList: item.serviceList || []
      })
    })
    result.list = newList
  }
  return result
}

// type: 1-福利品 2-小贵子供应链 3-老陶供应链  
async function SearchGoodsBySupply(data) {
  const result = await Tb1688Api.RequestData({ url: 'searchAliSupplyItem', data })
  return formatData(result)
}

// 统一格式化接口返回的数据
function formatData(result) {
  if (result.list.length) {
    const arr = []
    result.list.map(item => {
      arr.push({
        goodsId: item.itemId,
        goodsName: item.title,
        price: +(item.minPrice / 100),
        imageUrl: item.imgUrl,
        serviceList: item.serviceList || [],
        category: item.catName,
        sold: item.salesCnt90d || item.salesCnt90D
      })
    })
    result.list = arr
  }
  return result
}

// 1688搜图
function SearchGoodsByImage(data) {
  return Tb1688Api.SearchGoodsByImage(data, Service_GetRelationId())
}

export default { GetPoolList, GetCategoryList, SearchGoodsByKeyword, SearchGoodsBySupply, SearchGoodsByImage }